import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import { LoadingScreen } from 'src/components/loading-screen';
import { DashboardLayout } from 'src/layouts';

// DASHBOARD
const DashboardPage = lazy(() => import('src/modules/dashboard/components/dashboard-page'));

// ADMIN
const AdminListPage = lazy(() => import('src/modules/admin/components/admin-list-page'));
const AdminFormPage = lazy(() => import('src/modules/admin/components/admin-form-page'));

// SHOPPING
const ShoppingListPage = lazy(() => import('src/modules/shopping/components/shopping-list-page'));
const ShoppingFormPage = lazy(() => import('src/modules/shopping/components/shopping-form-page'));

// CLIENT ADMINS
const ClientSelectionPage = lazy(() => import('src/modules/client-admins/components/client-selection-page'));
const ClientAdminListPage = lazy(() => import('src/modules/client-admins/components/client-admin-list-page'));
const ClientAdminFormPage = lazy(() => import('src/modules/client-admins/components/client-admin-form-page'));

export const backofficeRoutes = [
  {
    path: 'backoffice',
    element: (
      <DashboardLayout>
        <AuthGuard>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </AuthGuard>
      </DashboardLayout>
    ),
    children: [
      {
        path: 'home',
        element: <DashboardPage />,
      },
      {
        path: 'admin',
        children: [
          {
            index: true,
            element: <AdminListPage />,
          },
          {
            path: 'new',
            element: <AdminFormPage />,
          },
          {
            path: ':id/edit',
            element: <AdminFormPage />,
          },
        ],
      },
      {
        path: 'shoppings',
        children: [
          {
            index: true,
            element: <ShoppingListPage />,
          },
          {
            path: 'new',
            element: <ShoppingFormPage />,
          },
          {
            path: ':id/edit',
            element: <ShoppingFormPage />,
          },
        ],
      },
      {
        path: 'client-admins',
        children: [
          {
            index: true,
            element: <ClientSelectionPage />,
          },
          {
            path: ':clientId',
            element: <ClientAdminListPage />,
          },
          {
            path: ':clientId/new',
            element: <ClientAdminFormPage />,
          },
          {
            path: ':clientId/:adminId/edit',
            element: <ClientAdminFormPage />,
          },
        ],
      },
    ],
  },
];
